// #region Imports
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppService, Response as ApiResponse } from '../app.service';
import { DefaultWarehouse } from '../interfaces/warehouse';
// #endregion Imports

// #region ComponentDecorator
@Injectable({ providedIn: 'root' })
// #endregion ComponentDecorator
export class WarehouseService {
  // #region DependencyInjection
  private readonly appService: AppService = inject(AppService);
  // #endregion DependencyInjection

  // #region PublicMethods
  public getDefaultWarehouse(): Observable<ApiResponse<DefaultWarehouse>> {
    return this.appService.httpGet<DefaultWarehouse>('Warehouse', 'GetDefaultSellWarehouse');
  }
  // #endregion PublicMethods
}
